const { statusSlugToLabel } = require('./statusTranslations')
// const { insertComment } = require('../API/comments')
const insertComment = async ({ chargingPointUUID, payload }) => {
    try {

        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingPointUUID}/comment`

        const api = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: JSON.stringify(payload),
        })

        const response = await api.json()
        return response.data
    } catch (error) {
        console.error('Could not create comment', error)
    }
}
/*
 * API COMMENTS
 */
const composeCommentNewChargingpointByApi = async ({ chargingpoint, name }) => {
  const comment = await insertComment({
    chargingPointUUID: chargingpoint.uuid,
    payload: {
      comment_type: 'system',
      message_type: 'location_import_source',
      message: `The location proposal was created through the API integration with ${name}.`,
    },
  })

  return comment
}

const composeCommentStatusUpdateByApi = async ({ chargingpoint, from, to, name }) => {
  // todo:: abstract this first part? YES!
  from = from ? from : chargingpoint.meta?.action.from
  to = to ? to : chargingpoint.meta?.action.to

  if (from === to) {
    return
  }

  from = statusSlugToLabel({ status: from, language: 'en' }).toLowerCase()
  to = statusSlugToLabel({ status: to, language: 'en' }).toLowerCase()

  const comment = await insertComment({
    chargingPointUUID: chargingpoint.uuid,
    payload: {
      comment_type: 'system',
      message_type: 'status_change_import_source',
      message: `The status has been changed from ${from} to ${to} as a result of the API integration with ${name}.`,
      metadata: {
        oldStatus: from,
        newStatus: to
      }
    },
  })

  return comment
}

/*
 * IMPORT COMMENTS
 */
const composeCommentNewChargingpointByImport = async ({ chargingpoint, name }) => {
  const source = name && String(name).trim() ? name : 'EVtools'

  const comment = await insertComment({
    chargingPointUUID: chargingpoint.uuid,
    payload: {
      message_type: 'single_import',
      message: `The location proposal was created based on a one-time import for ${source}`,
      comment_type: 'system',
      metadata: {
        import_source: source
      }
    }
  })

  return comment
}

const composeCommentStatusUpdateByImport = async ({ chargingpoint, from, to, name = '' }) => {
  from = from ? from : chargingpoint.meta.action.from
  to = to ? to : chargingpoint.meta.action.to

  if (from === to) {
    return
  }

  from = statusSlugToLabel({ status: from }).toLowerCase()
  to = statusSlugToLabel({ status: to }).toLowerCase()

  const source = name !== '' ? name : 'Evtools'
  const comment = await insertComment({
    chargingPointUUID: chargingpoint.uuid,
    payload: {
      message_type: 'single_import',
      message: `The status has been changed from ${from} to ${to} as a result of a one-time import for ${source}.`,
      comment_type: 'system',
      metadata: {
        import_source: source
      }
    }
  })

  return comment
}

/*
 * MERGE COMMENTS
 */
const composeCommentMergeAccepted = async ({ chargingpoint, name, mergedWithId, reason }) => {
  const message_type = reason ? 'merge_reason' : 'merge_no_reason'

  const message = reason ?
    `${name} has changed the coordinates based on the duplicate location ${mergedWithId} with reason: ${reason}` :
    `${name} has changed the coordinates based on the duplicate location ${mergedWithId}.`

  const comment = await insertComment({
    chargingPointUUID: chargingpoint.uuid,
    payload: {
      message_type,
      message,
      comment_type: 'system',
      metadata: {
        duplicate: mergedWithId,
        reason
      },
      user: {
        name
      }
    }
  })
  return comment
}

// MERGE REJECT
const composeCommentMergeRejected = async ({ chargingpoint, name, rejectedId }) => {
  const comment = await insertComment({
    chargingPointUUID: chargingpoint.uuid,
    payload: {
      message_type: 'merge_rejected',
      message: `${name} has confirmed that this location is separate from ${rejectedId}.`,
      comment_type: 'system',
      metadata: {
        duplicate: rejectedId,
      },
      user: {
        name
      }
    }
  })
  return comment
}

module.exports = {
  composeCommentNewChargingpointByApi,
  composeCommentNewChargingpointByImport,
  composeCommentStatusUpdateByApi,
  composeCommentStatusUpdateByImport,
  composeCommentMergeAccepted,
  composeCommentMergeRejected,
}
